module.exports = __webpack_public_path__ + "static/media/August_2026_4.9b93a547.webp";